module.exports = __webpack_public_path__ + "img/Workflow-ability-05.c75fb305.png";